import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { StartupService } from './startup.service';

@Injectable()
export class BuyOnlineService {

  constructor(private startupService: StartupService) {
  }

  getBuyOnlineLink(productName: string, opacity: string, colorName: string) {
    console.log("Datos", productName, opacity,colorName);
    let links = this.startupService.startupData.BuyOnlineLinks;
    console.log("links",links)
    let link = links.find(x => x.ProductName.toLowerCase() == productName.toLowerCase() && x.Opacity.toLowerCase() == opacity.toLowerCase() && x.ColorName.toLowerCase() == colorName.toLowerCase());
    console.log("link",link)
    
    if (link != null) {
      return link.BuyUrl;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/buy-online.service.ts